"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createContext = void 0;
const utils_1 = require("./utils");
const utils_common_get_cookie_1 = __importDefault(require("@gcloud-npm/utils.common.get-cookie"));
const utils_page_generate_page_id_1 = __importDefault(require("@gcloud-npm/utils.page.generate-page-id"));
const utils_common_get_ga_cookie_1 = __importDefault(require("@gcloud-npm/utils.common.get-ga-cookie"));
const utils_page_get_sess_id_1 = __importDefault(require("@gcloud-npm/utils.page.get-sess-id"));
const utils_page_get_tab_id_1 = __importDefault(require("@gcloud-npm/utils.page.get-tab-id"));
const utils_page_get_context_seo_info_1 = __importDefault(require("@gcloud-npm/utils.page.get-context-seo-info"));
const utils_secure_cookie_storage_1 = __importDefault(require("@gcloud-npm/utils.secure.cookie-storage"));
const ga_events_1 = __importDefault(require("../ga-events"));
const SC_LOGGED_COOKIE_NAME = "sc.logged";
const SC_COOKIE_DURATION = "365d";
const COOKIE_NAME_LOGGED = "seth-session-logged";
const COOKIE_NAME_SOFT_LOGGED = "seth-session-softlogged";
const setScLoggedCookie = (hasSethSession) => {
    try {
        const cookieStorageClient = new utils_secure_cookie_storage_1.default({
            prefix: "",
            duration: SC_COOKIE_DURATION,
        });
        if (hasSethSession) {
            cookieStorageClient.setItem(SC_LOGGED_COOKIE_NAME, true);
        }
        else {
            cookieStorageClient.removeItem(SC_LOGGED_COOKIE_NAME);
        }
    }
    catch (error) {
        console.error(error);
    }
};
const removeNumberGroupsFromUrl = (urlString) => {
    let res = urlString;
    try {
        const currentUrl = new URL(urlString);
        const { host, protocol, port } = currentUrl;
        let { pathname } = currentUrl;
        pathname = pathname.split("/").map((tokenUrl) => {
            let isNotNumber = isNaN(tokenUrl);
            if (isNotNumber) {
                return tokenUrl;
            }
            return "";
        });
        pathname = pathname.filter((item) => !!item);
        pathname.unshift(host);
        pathname.unshift(`${protocol}/`);
        pathname = pathname.join("/");
        res = pathname;
    }
    catch (err) {
        console.error(err);
    }
    return res;
};
const createContext = ({ context, setUserPqInfo, setUserCompatibilities, setUserPromotions, setUserDefinitions, setUserBundle, setUserLgInfo, setUserPoInfo, setContextData, setUserRecom, setCustomer, ad_storage, analytics_storage, ad_user_data, ad_personalization, isReactApp, onEnd, }) => __awaiter(void 0, void 0, void 0, function* () {
    // 1) Formamos el objeto context inicial
    const ssrContext = context;
    let initialContextData = {};
    // 1.1) Traemos ts de local storage, pero si han pasado mas de 6 meses se borra para recargar la info (se encarga getUserPersistedInfo)
    const persistedInfo = Object.assign({}, (0, utils_1.getUserPersistedInfo)());
    let userName = "";
    let userType = "";
    let userIdPartyHash = "";
    let userCUCFijoHash = "";
    let userCUCMovilHash = "";
    let userCUCPrepagoHash = "";
    if (persistedInfo) {
        userName = persistedInfo.userName || "";
        userType = persistedInfo.userType || "";
        userIdPartyHash = persistedInfo.userIdPartyHash || "";
        userCUCFijoHash = persistedInfo.userCUCFijoHash || "";
        userCUCMovilHash = persistedInfo.userCUCMovilHash || "";
        userCUCPrepagoHash = persistedInfo.userCUCPrepagoHash || "";
    }
    const isSethLogged = (0, utils_common_get_cookie_1.default)(COOKIE_NAME_LOGGED);
    const isSethSoftLogged = (0, utils_common_get_cookie_1.default)(COOKIE_NAME_SOFT_LOGGED);
    const hasSethSession = Boolean(isSethLogged || isSethSoftLogged);
    setScLoggedCookie(hasSethSession);
    if ((!persistedInfo || !persistedInfo.userType) && isSethLogged) {
        userType = "Telco";
    }
    let contextURL = window.location.href;
    if (isReactApp) {
        contextURL = removeNumberGroupsFromUrl(contextURL);
    }
    try {
        const pageId = (0, utils_page_generate_page_id_1.default)();
        window.pageId = pageId;
        // 1.2) Creamos el objeto context con info inicial y la info recogida anteriormente
        initialContextData = Object.assign(Object.assign(Object.assign(Object.assign({}, ssrContext), { numLocationChanges: 0, tabId: (0, utils_page_get_tab_id_1.default)(), pageWebCode: null, pageName: null, pageWebName: null, pageProductCode: null, pageProductName: null, clientIDs: {
                pageId,
                ga: (0, utils_common_get_ga_cookie_1.default)(),
                sessId: (0, utils_page_get_sess_id_1.default)(),
                cookiesHandled: false,
            }, pageSegment: `${process.env.NEXT_PUBLIC_ENV_SEGMENT}`, contextURL, subseg: false, userPriority: false, version: `${process.env.NEXT_PUBLIC_VERSION_JS}` || "unknown" }), (0, utils_page_get_context_seo_info_1.default)()), { userName,
            userType,
            userIdPartyHash,
            userCUCFijoHash,
            userCUCMovilHash,
            userCUCPrepagoHash });
        // 1.3) Antes de acabar limpiamos las variables dentro de initialContextData (esta info ahora la tendriamos en main y no hace falta en context)
        if (initialContextData) {
            delete initialContextData.geo;
        }
        setContextData(initialContextData);
    }
    catch (error) {
        console.error(error);
    }
    // 2) Extraemos la info de usuario
    let userPq = {};
    let userPo = {};
    let userFlags = [];
    let userLg = null;
    let userRecom = null;
    // 2.1) userPq
    if (persistedInfo.userPq) {
        userPq = persistedInfo.userPq;
        userFlags = (persistedInfo === null || persistedInfo === void 0 ? void 0 : persistedInfo.userFlags) || [];
    }
    setUserPqInfo({
        userPq,
        userFlags,
    });
    // 2.2) userLg
    if (persistedInfo.userLg) {
        userLg = persistedInfo.userLg;
        setUserLgInfo({ userLg });
    }
    // 2.3) userRecom
    if (persistedInfo.userRecom) {
        userRecom = persistedInfo.userRecom;
        setUserRecom({ userRecom });
    }
    // 2.4) userPo
    if (persistedInfo.userPo) {
        userPo = persistedInfo.userPo;
        setUserPoInfo({ userPo });
    }
    // 2.5) userCompatibilities
    let userCompatibilities = null;
    if (setUserCompatibilities &&
        persistedInfo &&
        persistedInfo.userCompatibilities) {
        userCompatibilities = persistedInfo.userCompatibilities;
        setUserCompatibilities({ userCompatibilities });
    }
    // 2.6) userBundle
    let userBundle = null;
    if (setUserCompatibilities && persistedInfo && persistedInfo.userBundle) {
        userBundle = persistedInfo.userBundle;
        setUserBundle({ userBundle });
    }
    // 2.7 userDefinitions
    let userDefinitions = null;
    if (setUserDefinitions && persistedInfo && persistedInfo.userDefinitions) {
        userDefinitions = persistedInfo.userDefinitions;
        setUserDefinitions({ userDefinitions });
    }
    // 2.8 customer campaings
    let customer = null;
    if (setCustomer && persistedInfo && persistedInfo.customer) {
        customer = persistedInfo.customer;
        setCustomer({ customer });
    }
    // 2.9) userPromotions
    let userPromotions = null;
    if (setUserPromotions &&
        persistedInfo &&
        persistedInfo.userPromotions) {
        userPromotions = persistedInfo.userPromotions;
        setUserPromotions({ userPromotions });
    }
    // 3) Enviamos a GA si el cliente ha aceptado cookies y tambien info de este
    try {
        (0, ga_events_1.default)({
            context: initialContextData,
            setContextData,
            ad_storage,
            analytics_storage,
            ad_user_data,
            ad_personalization,
        });
    }
    catch (error) {
        console.error(error);
    }
    if (onEnd) {
        onEnd({
            context: Object.assign(Object.assign({}, initialContextData), { userPo,
                userFlags,
                userLg,
                userCompatibilities,
                userPromotions,
                userBundle,
                userDefinitions,
                customer }),
            userCompatibilities,
            userPromotions,
            userPo,
            userBundle,
            userFlags,
            userRecom,
            userPq,
            customer,
        });
    }
});
exports.createContext = createContext;
exports.default = exports.createContext;
//# sourceMappingURL=index.js.map